export enum EMarginSize {
  narrow = 'narrow',
  normal = 'normal'
}

export enum EFontSize {
  extraSmall = 'extraSmall',
  small = 'small',
  normal = 'normal',
  large = 'large',
  extraLarge = 'extraLarge'
}

export enum EFontFamily {
  dmSans = 'dmSans',
  dmMono = 'dmMono',
  arial = 'arial',
  timesNewRoman = 'timesNewRoman'
}

export const getFontFamilyCss = (font: EFontFamily): string => {
  switch (font) {
    case EFontFamily.dmSans:
      return '"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif';
    case EFontFamily.dmMono:
      return '"DM Mono", "Courier New", monospace';
    case EFontFamily.arial:
      return 'Arial, Helvetica, sans-serif';
    case EFontFamily.timesNewRoman:
      return '"Times New Roman", Times, serif';
  }
};

export const getGoogleFontLink = (font: EFontFamily): string | null => {
  switch (font) {
    case EFontFamily.dmSans:
      return '<link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap" rel="stylesheet" />';
    case EFontFamily.dmMono:
      return '<link href="https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap" rel="stylesheet" />';
    default:
      return null;
  }
};

export const getGoogleFontUrl = (font: EFontFamily): string | null => {
  switch (font) {
    case EFontFamily.dmSans:
      return 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap';
    case EFontFamily.dmMono:
      return 'https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap';
    default:
      return null;
  }
};

export enum EPageOrientation {
  portrait = 'portrait',
  landscape = 'landscape'
}

export enum EShowPageSetting {
  onAllPages = 'onallpages',
  onlyOnTheFirstPage = 'onlyonthefirstpage'
}

export enum ECurrencySymbolDisplay {
  All = 'all',
  None = 'none',
  FirstLastPerGroup = 'firstLastPerGroup'
}

export enum EFooterAlignment {
  left = 'left',
  center = 'center',
  right = 'right'
}
